export const SPECIAL_TRAVEL_CARD_GROUP = 'AGCORP'

// The ferry product codes each Travel Card discount level prices at, two a level
export const TRAVEL_CARD_PRODUCT_CODES = {
  EPA: '1',
  EPD: '1',
  EPB: '2',
  EPE: '2',
  EPC: '3',
  EPF: '3',
}

/**
 * The discount level a customer is shown: FRQ for the corporate group (AGCORP),
 * and for every other group - retirees included - the level of their default
 * product code, as for a regular customer. '' when that code has no level.
 */
export const getTravelCardDiscountLevel = customerAccount =>
  customerAccount?.groupCode === SPECIAL_TRAVEL_CARD_GROUP
    ? 'FRQ'
    : TRAVEL_CARD_PRODUCT_CODES[customerAccount?.defaultProductCode] || ''

let controller = null

export const getSharedController = () => {
  if (controller) {
    controller.abort()
  }
  controller = new AbortController()
  return controller
}
